import {api} from '../../services/api';
import {PromptSettingRequest, PromptSettingResponse} from './types';

interface ApiResponse<T> {
    success: boolean;
    data: T;
    message?: string;
}

export const promptSettingService = {
    async getPromptSetting(): Promise<PromptSettingResponse> {
        const response = await api.get<ApiResponse<PromptSettingResponse>>('/api/v1/users/ai-config/prompt-setting');
        if (response.data?.success && response.data.data) {
            return response.data.data;
        }
        throw new Error(response.data?.message || '获取Prompt设定失败');
    },

    async updatePromptSetting(request: PromptSettingRequest): Promise<PromptSettingResponse> {
        const response = await api.put<ApiResponse<PromptSettingResponse>>('/api/v1/users/ai-config/prompt-setting', request);
        if (response.data?.success && response.data.data) {
            return response.data.data;
        }
        throw new Error(response.data?.message || '更新Prompt设定失败');
    },

    async resetPromptSetting(): Promise<PromptSettingResponse> {
        const response = await api.delete<ApiResponse<PromptSettingResponse>>('/api/v1/users/ai-config/prompt-setting');
        if (response.data?.success && response.data.data) {
            return response.data.data;
        }
        throw new Error(response.data?.message || '重置Prompt设定失败');
    }
};
